const customStyles = {
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  option: (base: any, { data, isFocused, isSelected }: any) => {
    return {
      ...base,
      color: isSelected && data.color ? '#fff' : data.color,
      backgroundColor: isSelected
        ? data.color || '#dfdfdf'
        : isFocused
        ? '#eee'
        : '#fff',
      ':active': {
        color: data.color,
        backgroundColor: '#efefef',
      },
    };
  },
  singleValue: (base: any, { data }: any) => ({ ...base, color: data.color }),
  multiValue: (styles: any) => {
    return {
      ...styles,
      backgroundColor: 'rgba(255, 153, 184, 0.25)',
      height: '2.143rem',
      alignItems: 'center',
    };
  },
  multiValueLabel: (styles: any) => ({
    ...styles,
  }),
  multiValueRemove: (styles: any) => ({
    ...styles,
    height: '2.143rem',
    ':hover': {
      backgroundColor: '#ff99b8',
      color: 'black',
    },
  }),
};

export default customStyles;
